// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__33l8U","buttons":"Footer_buttons__2bE34"};